import useBotValidatedAction, {
  BotValidatedState,
  UseBotValidatedActionReturn,
} from 'hooks/useBotValidatedAction/useBotValidatedAction';

export const ROOM_CREATION_VALIDATOR_TIMEOUT_MS = 12_000;

export interface UseRoomCreationValidatorOptions {
  action: () => Promise<unknown>;
  onSuccess?: () => void;
  onReject?: () => void;
}

export type UseRoomCreationValidatorReturn = UseBotValidatedActionReturn;

const useRoomCreationValidator = ({
  action,
  onSuccess,
  onReject,
}: UseRoomCreationValidatorOptions): UseRoomCreationValidatorReturn =>
  useBotValidatedAction<unknown>({
    action,
    onSuccess: onSuccess ? () => onSuccess() : undefined,
    onReject,
    timeoutMs: ROOM_CREATION_VALIDATOR_TIMEOUT_MS,
    timeoutIsSuccess: true,
  });

export type { BotValidatedState };

export default useRoomCreationValidator;
